import React, { useRef, useState } from 'react';
import styles from './styles';
import PropTypes from 'prop-types';
import emailjs from '@emailjs/browser';

const SupportHotline = ({ block }) => {
  if (!block) return '';
  const { primary } = block;
  const title1 = primary?.title1[0].text;
  const description = primary?.description[0].text;
  const emailTo = primary?.email_to;

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [text, setText] = useState('');
  const [details, setDetails] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [sending, setSending] = useState(false);

  const form = useRef();
  const formMobile = useRef();

  const sendEmail = (e) => {
    setSending(true);
    e.preventDefault();

    emailjs.sendForm('service_z51h2hk', 'template_b0xckqg', form.current, 'EHLLCbLlIfGaD7hiA')
      .then((result) => {
          setFirstName('');
          setLastName('');
          setContactNumber(''); 
          setInvoiceNumber('');
          setText('');
          setDetails('');
          setSending(false);
          alert("Successfully sent email!");
      }, (error) => {
          console.log(error.text);
          setSending(false);
      });
  };

  const sendEmailMobile = (e) => {
    setSending(true);
    e.preventDefault();

    emailjs.sendForm('service_z51h2hk', 'template_hi7httu', formMobile.current, 'EHLLCbLlIfGaD7hiA')
      .then((result) => {
          setPhoneNumber('');
          setSending(false);
          alert("Successfully sent email!");
      }, (error) => {
          console.log(error.text);
          setSending(false);
      });
  };
  
  

  const characterLimit = 2000;

  const handleChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= characterLimit) {
      setText(newText);
    }
  };

  return (
    <>
      <div className='main-container'>
        <div className='header-container'>
          <div className='header'>
            <img draggable="false"  src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/support_hotline.png?v=1714058481' className='header-icon' alt='header-icon'/>
            <h3 className='title'>{title1}</h3>
          </div>
          <p className='description'>{description}</p>
        </div>

        <div className='input-section-desktop'>
        <form ref={form} onSubmit={sendEmail}>
          <input className='input' type="text" hidden name="details" value={details}/>
          <input className='input' type="text" hidden name="email_to" value={emailTo}/>
					<input className='input' type="text" hidden name="region" value={'SG'}/>

          <div className='input-row'>
            <div className='input-container'>
              <div className='label-container'>
                <label className='label'>First name</label><span className='required'>*</span>
              </div>
              <input required className='input' type="text" name="first_name" placeholder='First name' value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
            </div>

            <div className='input-container'>
              <div className='label-container'>
                <label className='label'>Last name</label><span className='required'>*</span>
              </div>
              <input required className='input' type="text" name="last_name" placeholder='Last name' value={lastName} onChange={(e) => setLastName(e.target.value)}/>
            </div>
          </div>

          <div className='input-row'>
            <div className='input-container'>
              <div className='label-container'>
                <label className='label'>Contact Number/Email</label><span className='required'>*</span>
              </div>
              <input
                required 
                className='input'
                type="text"
                name="contact_number"
                placeholder='Contact Number/Email'
                value={contactNumber}
                onChange={(e) => {
                  setContactNumber(e.target.value),
                  setDetails(`<b>Contact Number/Email:</b> ${e.target.value}<br> <b>Invoice Number:</b> ${invoiceNumber}`)
                }}
              />
            </div>

            <div className='input-container'>
              <div className='label-container'>
                <label className='label'>Invoice Number</label><span className='required'>*</span>
              </div>
              <input
                required
                className='input'
                type="text"
                name="invoice"
                placeholder='Invoice Number'
                value={invoiceNumber}
                onChange={(e) => {
                  setInvoiceNumber(e.target.value),
                  setDetails(`<b>Contact Number/Email:</b> ${contactNumber}<br> <b>Invoice Number:</b> ${e.target.value}`)
                }}
              />
            </div>
          </div>

          <div className='label-container'>
            <label required className='label'>Please describe the issue that you are facing: </label><span className='required'>*</span>
          </div>
          <textarea
            required
            className='textarea' type="textarea" name="message" placeholder='What are the issues that you are facing?'
            value={text}
            onChange={handleChange}
            rows={4}
            cols={50}
          />
          <div className='counter-container'>
            <p className='counter'>{text.length} / {characterLimit}</p>
          </div>

          <div className='submit-container'>
            <button className='submit' type="submit">
              {sending ? (
                <>
                  {`Sending`}
                  <span className="loader" />
                </>
              ) : (
                "Send Message"
              )}
            </button>
          </div>
        </form>
        </div>

        <div className='input-section-mobile'>
          <form ref={formMobile} onSubmit={sendEmailMobile}>
            <input className='input' type="text" hidden name="region" value={'SG'}/>
            <input className='input' type="text" hidden name="email_to" value={emailTo}/>

            <input required className='input-mobile' type="text" name="phonenumber" placeholder='Your phone number' value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}/>

            <div className='submit-container'>
              <button className='submit' type="submit">
                {sending ? (
                  <>
                    {`Sending`}
                    <span className="loader" />
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
SupportHotline.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      title1: PropTypes.array,
      description: PropTypes.array,
    }),
  }),
};

SupportHotline.defaultProps = {
  block: null,
};

export default SupportHotline;